import React from 'react';
import { Spin } from 'antd';

export const LoadingState = () => {
  return (
    <div className="layout-content">
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <Spin size="large" />
      </div>
    </div>
  );
};